import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Unchecked from 'images/icons/Unchecked.svg?react';
import { useModalStore } from 'stores/modal';
import { ModalType } from 'core/useCases/modal/types';
import { isPastDate } from 'utils/dateTimeFormat';
import ActivityType from 'core/enums/activityType';
import EventStatus from 'core/enums/eventStatus';
import { useEventById } from 'core/api/events';
import Button from 'components/Button';

type MarkEventAsCompleteButtonProps = {
    eventId: string;
    iconButton?: boolean;
};

const MarkEventAsCompleteButton: FC<MarkEventAsCompleteButtonProps> = ({ eventId, iconButton = true }) => {
    const { t } = useTranslation();
    const openModal = useModalStore((s) => s.openModal);
    const event = useEventById(eventId).data;

    if (!event) {
        return null;
    }

    const { date, status } = event;
    const eventIsPast = isPastDate(date);

    if (!eventIsPast) {
        return null;
    }

    const openMarkTaskAsCompleteModal = () => {
        openModal({
            defaultValues: {
                activityType: ActivityType.Event,
                id: eventId,
                isAlreadyCompleted: EventStatus.Completed === status,
            },
            title: t('common.mark-as-complete'),
            type: ModalType.ActivityReport,
        });
    };

    return (
        <div>
            {iconButton ? (
                <button
                    onClick={() => openMarkTaskAsCompleteModal()}
                    title={t('common.mark-as-complete')}
                    type="button"
                >
                    <Unchecked />
                </button>
            ) : (
                <Button
                    onClick={() => openMarkTaskAsCompleteModal()}
                    title={t('common.mark-as-complete')}
                    type="button"
                    withShadow
                >
                    {t('common.mark-as-complete')}
                </Button>
            )}
        </div>
    );
};

export default MarkEventAsCompleteButton;
